const WhiteSpace=(value)=>{
  if (!/\S/.test(value)) {
    return true;
  }
};
export default WhiteSpace;